import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Composant pour remettre la page en haut à chaque changement d'onglet
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
